import { DataTableSkeleton } from "../ui/DataTableSkeleton.js";
import { LoadingStatus, Skeleton } from "../ui/Skeleton.js";

export function ServicesOpsSkeleton() {
  return (
    <div className="space-y-5" role="status" aria-busy="true">
      <LoadingStatus label="Loading paid services operations" />
      <div className="grid gap-3 sm:grid-cols-3">
        {["Available numbers", "Assigned numbers", "Total inventory"].map((label) => (
          <div key={label} className="rounded-[var(--card-radius)] border border-border-default bg-surface-raised p-4 shadow-card">
            <p className="text-xs font-semibold uppercase tracking-wide text-content-muted">{label}</p>
            <Skeleton className="mt-3 h-7 w-16" />
          </div>
        ))}
      </div>
      <div className="grid gap-3 rounded-[var(--card-radius)] border border-border-default bg-surface-raised p-4 sm:grid-cols-2 lg:grid-cols-5">
        <Skeleton className="h-10 w-full rounded-lg" />
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} className="h-10 w-full rounded-lg" />
        ))}
      </div>
      <DataTableSkeleton
        headers={["Agent", "Product", "Enrollment", "Payment", "Fulfillment", "Call delivery", "Actions"]}
        cellVariants={["multiline", "text", "badge", "badge", "multiline", "text", "text"]}
        loadingLabel="Loading service enrollments"
      />
    </div>
  );
}
